import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactInputMask from "react-input-mask";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import CountriesSelect from "../../common/CountriesSelect";
import StatesSelect from "../../common/StatesSelect";
import CitiesSelect from "../../common/CitiesSelect";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import FormTextAreaInput from "src/_common/components/form-elements/textarea/textareaInput";
import FormMaskedInput from "src/_common/components/form-elements/maskedInput/maskedInput";
import { allowNumberOnly } from "src/_config";
import "react-select-search/style.css";
import { useCommonApi } from "src/_common/hooks/actions/commonApiCall/appCommonApiCallHook";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";

interface FanMagazineModalProps {
  onClose: Function;
  shouldShow: boolean;
}

interface FanMagazineModalValues {
  email: string;
  name: string;
  address: string;
  city_name: string;
  zipcode: string;
  phone: string;
  country_id: string;
  state_id: string;
  city_id: string;
}

const FanMagazineModalSchema = yup.object().shape({
  email: yup.string().email("Email must be valid").required("Email is required"),
  name: yup.string().required("Name is required"),
  address: yup.string().required("Address is required"),
  city_name: yup.string(),
  // .when("selectedCityId", {
  //   is: (val: any) => val === "0",
  //   then: yup.string().required("City is required"),
  //   otherwise: yup.string(),
  // }),
  zipcode: yup.string().required("Zipcode is required"),
  phone: yup
    .string()
    .required("Mobile Number is required")
    .test("isValidPhone", "Mobile Number is required", (value: any) => {
      const phone = value?.replace(/[-| |(|)|_]/g, "");
      return phone && phone.length > 0;
    })
    .test("isValidPhone", "Mobile Number must be valid", (value: any) => {
      const phone = value?.replace(/[-| |(|)|_]/g, "");
      return phone && phone.length === 10;
    }),
  // country_id: yup.string().required("Country is required"),
  // state_id: yup.string().required("State is required"),
  // city_id: yup.string().required("City is required"),
});

export default function FanMagazineModal({ onClose, shouldShow }: FanMagazineModalProps) {
  const { control, errors, setValue, handleSubmit } = useForm<FanMagazineModalValues>({
    // mode: "onChange",
    resolver: yupResolver(FanMagazineModalSchema),
    defaultValues: {
      email: "",
      name: "",
      address: "",
      city_name: "",
      zipcode: "",
      phone: "",
      // country_id: "",
      // state_id: "",
      // city_id: "",
    },
  });

  const toast = useToaster();
  const commonApi = useCommonApi();
  const [newCity, setNewCity] = useState<boolean>(false);
  const [selectedCountryId, setSelectedCountryId] = useState<any>();
  const [selectedStateId, setSelectedStateId] = useState<any>();
  const [selectedCityId, setSelectedCityId] = useState<any>();
  const [formValues, setFormValues] = useState<any>({
    email: "",
    name: "",
    address: "",
    city_name: "",
    zipcode: "",
    phone: "",
  });

  const userDetails = useAppUserDetailsSelector();

  const onChange = (val: any, fieldName: any) => {
    let x = { ...formValues };
    x[fieldName] = val.target.value;
    setFormValues(x);
  };

  const sendNewsletter = (values: FanMagazineModalValues) => {
    let { name, email, address, phone, zipcode, city_name } = values;
    // console.log({ formValues });
    phone = values.phone.replace(/[-| |(|)|_]/g, "");
    // if (!name) {
    //   toast.error("Please Enter Name");
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    //   toast.error("Please Enter valid Email address");
    // } else if (!address) {
    //   toast.error("Please Enter Address");
    // } else
    if (phone.length != 10) {
      toast.error("Please Enter Valid Phone Number");
    } else if (!selectedCountryId) {
      toast.error("Please select Country");
    } else if (!selectedStateId) {
      toast.error("Please select State");
    } else if (!selectedCityId) {
      toast.error("Please select City");
    } else if (selectedCityId == "0" && !values?.city_name) {
      toast.error("Please enter City Name");
      // } else if (!zipcode) {
      //   toast.error("Please Enter ZipCode");
    } else {
      let params = {
        ...values,
        phone,
        country_id: selectedCountryId,
        state_id: selectedStateId,
        city_id: selectedCityId,
        signup_from: "IR",
      };
      console.log({ params });
      commonApi.callNewsletterSignup(
        params,
        (message: string, resp: any) => {
          toast.success(message);
          onClose();
        },
        (message: string) => {
          toast.error(message);
        }
      );
    }
  };

  useEffect(() => {
    console.log({ errors });
  }, [errors]);

  useEffect(() => {
    if (userDetails) {
      setValue("name", userDetails?.full_name || "");
      setValue("email", userDetails?.email || "");
      setValue("phone", userDetails?.phone || "");
    }
  }, [userDetails]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
        size="lg"
      >
        <Modal.Header>
          <h2 className="modal-header-text">Signup for Fan Magazine</h2>
          <button type="button" className="btn-close" onClick={() => onClose()}></button>
        </Modal.Header>
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <p>Subscribe to our Fan Magazine and get the latest to your address!</p>
            <div className="mb-3">
              {/* <label className="form-label">First Name *</label> */}
              <Controller
                control={control}
                name="name"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormTextInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.name}
                    placeholder="Enter Name"
                  />
                )}
              />
            </div>
            <div className="mb-3">
              {/* <label className="form-label">Email *</label> */}
              <Controller
                control={control}
                name="email"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormTextInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.email}
                    placeholder="Enter Email"
                  />
                )}
              />
            </div>
            <div className="mb-3">
              {/* <label className="form-label">Address *</label> */}
              <Controller
                control={control}
                name="address"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormTextAreaInput
                    rows={3}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.address}
                    placeholder="Enter Address"
                  />
                )}
              />
            </div>
            <div className="mb-3">
              {/* <label className="form-label">Contact No {field.is_required ? "*" : ""}</label> */}
              <Controller
                control={control}
                name="phone"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormMaskedInput
                    name={name}
                    mask={"(999) 999 9999"}
                    maskChar=" "
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="tel"
                    placeholder="Enter Mobile Number"
                    error={errors.phone}
                  />
                )}
              />
              {/* {errors?.phone && <div className="invalid-feedback">{errors?.phone?.message}</div>} */}
            </div>
            {/* <input
              type="text"
              maxLength={50}
              autoComplete="new-password"
              className="input_box"
              placeholder="Enter name..."
              // value={this.state.name}
              onChange={(e) => onChange(e, "name")}
            />
            <input
              type="email"
              // value={this.state.email}
              maxLength={50}
              className="input_box"
              placeholder="Enter your email address"
              onChange={(e) => onChange(e, "email")}
            /> */}
            {/* <textarea
              autoComplete="new-password"
              className="input_box"
              // value={this.state.address}
              placeholder="Enter your address"
              onChange={(e) => onChange(e, "address")}
            ></textarea> */}

            {/* <ReactInputMask
              mask="(999) 999 - 9999"
              id="phone"
              // value={this.state.phone}
              inputMode="numeric"
              onChange={(e) => onChange(e, "phone")}
            >
              {(inputProps: any) => (
                <input {...inputProps} placeholder="Phone Number" className="input_box" type="text" />
              )}
            </ReactInputMask> */}
            <div className="d-flex justify-content-between">
              <div className="mb-3" style={{ width: "49%" }}>
                <CountriesSelect
                  selectedCountryId={selectedCountryId}
                  setSelectedCountryId={setSelectedCountryId}
                  className={"form-control text-muted"}
                />
                {/* {!selectedCountryId && <div className="invalid-feedback">Please select Country</div>} */}
              </div>
              <div className="mb-3" style={{ width: "49%" }}>
                <StatesSelect
                  selectedCountryId={selectedCountryId}
                  selectedStateId={selectedStateId}
                  setSelectedStateId={setSelectedStateId}
                  className={"form-control text-muted"}
                  setType={1}
                />
                {/* {!selectedStateId && <div className="invalid-feedback">Please select State</div>} */}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="mb-3" style={{ width: "49%" }}>
                <CitiesSelect
                  selectedStateId={selectedStateId}
                  selectedCityId={selectedCityId}
                  setSelectedCityId={setSelectedCityId}
                  className={"form-control text-muted"}
                  setNewCity={setNewCity}
                />
                {/* {!selectedCityId && <div className="invalid-feedback">Please select City</div>} */}
              </div>
              <div className="mb-3" style={{ width: "49%" }}>
                {/* <label className="form-label">Zip</label> */}
                <Controller
                  control={control}
                  name="zipcode"
                  render={({ onChange, onBlur, value, name, ref }) => (
                    <FormTextInput
                      name={name}
                      onChange={(e) => {
                        onChange(e);
                        // allowNumberOnly(e, name, setValue);
                      }}
                      maxLength={8}
                      onBlur={onBlur}
                      value={value}
                      inputRef={ref}
                      type="tel"
                      error={errors.zipcode}
                      placeholder="Enter Zipcode"
                    />
                  )}
                />
              </div>
            </div>
            {newCity && (
              <div className="mb-3">
                <Controller
                  control={control}
                  name="city_name"
                  render={({ onChange, onBlur, value, name, ref }) => (
                    <FormTextInput
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      inputRef={ref}
                      type="text"
                      // error={errors.city_name}
                      placeholder="Enter City Name"
                    />
                  )}
                />
                {/* <input
                  type="text"
                  // style={newCity ? showplan : hideplan}
                  maxLength={50}
                  autoComplete="new-password"
                  className="input_box form-control"
                  placeholder="Enter City Name"
                  // value={this.state.city_name}
                  onChange={(e) => onChange(e, "city_name")}
                /> */}
                {/* {!selectedCountryId && <div className="invalid-feedback">Please select Country</div>} */}
              </div>
            )}
            {/* <input
              type="text"
              autoComplete="new-password"
              className="input_box"
              // value={this.state.zipcode}
              placeholder="Enter Zipcode"
              onChange={(e) => onChange(e, "zipcode")}
              maxLength={6}
            /> */}

            {/* <button className="red-btn" onClick={sendNewsletter}>
              GET THE MAGAZINE
            </button> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap w-100 mb-3">
            <button
              type="button"
              className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3"
              onClick={handleSubmit(sendNewsletter)}
            >
              GET THE MAGAZINE
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
